module.exports = clamp

function clamp(value, min, max) {
  return min < max
    ? (value < min ? min : value > max ? max : value)
    : (value < max ? max : value > min ? min : value)
}



//////////////////
// WEBPACK FOOTER
// /Users/tleunen/dev/react-mdl/~/clamp/index.js
// module id = 396
// module chunks = 0